export const supportedLocales = {
  IT: 'it',
  EN: 'en',
  EN_GB: 'en-GB'
};

export const DEFAULT_LOCALE = supportedLocales.IT;

export const COOKIE_LOCALE = 'sistinf-lang-choice';
